import React from "react";
import { CheckCircle, Warning, Clock, ShieldCheck, Prohibit } from "@phosphor-icons/react";

const CFG = {
  belum_termuat: { label: "Belum Termuat", cls: "status-belum", Icon: Clock },
  sudah_termuat: { label: "Sudah Termuat", cls: "status-termuat", Icon: CheckCircle },
  mismatch: { label: "Mismatch", cls: "status-mismatch", Icon: Warning },
  diverifikasi: { label: "Diverifikasi", cls: "status-diverifikasi", Icon: ShieldCheck },
  dibatalkan: { label: "Dibatalkan", cls: "status-dibatalkan", Icon: Prohibit },
};

export default function StatusPill({ status }) {
  const c = CFG[status] || CFG.belum_termuat;
  const Icon = c.Icon;
  return (
    <span className={`status-pill ${c.cls}`} data-testid={`status-${status}`}>
      <Icon size={12} weight="fill" />
      {c.label}
    </span>
  );
}
